import React, { useEffect, useRef, useState } from "react";
import PageTab from "@/components/i-pageTab/i-pageTab";
import PageTable from "@/components/i-pageTable/i-pageTable";
import { pageHomeList, pageHomeAdd, pageHomeEdit } from "@/api/operation";
import { Button, message, Modal, Space, Tag } from "antd";
import { customRequest, normFile, setIcons } from "@/utils/common";
import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";

const systemTypeList = [
  {
    label: "android",
    value: "0",
  },
  {
    label: "ios",
    value: "1",
  },
  {
    label: "小程序",
    value: "2",
  },
];
const AppStoreManager = () => {
  const dispatch = useDispatch();
  const {
    state: { app_store_type },
  } = useSelector((state: { dictInfo: any }) => state.dictInfo);

  const [pageData, setPageData] = useState<GetCmsPageHomeRes["rows"]>([]);
  const [total, setTotal] = useState(0);
  const [mainPicUploadProgress, setMainPicUploadProgress] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState<pageHomeAddParams>({
    status: "0",
    url: []
  });

  const [formData, setFormData] = useState<GetCmsPageHomeParams>({
    isnew: "",
    status: "",
    systemType: "",
    title: "",
    ypageNum: 1,
    ypageSize: 10,
  });
  const modalFormTab = [
    {
      label: "图标",
      name: "url",
      type: "upload",
      rules: [{ required: true, message: "请上传图标" }],
      labelCol: { span: 0, offset: 3 },
      getValueFromEvent: normFile,
      params: {
        maxCount: 1,
        fileList: modalFormData.url,
        beforeUpload: () => {
          setMainPicUploadProgress(true);
        },
        uploadMessage: mainPicUploadProgress ? (
          <div>
            {setIcons("LoadingOutlined")}
            <div>上传中...</div>
          </div>
        ) : (
          <div>
            {setIcons("PlusOutlined")}
            <div style={{ marginTop: 8 }}>上传</div>
          </div>
        ),
        customRequest: async (e: any) => {
          try {
            const data = await customRequest(e, modalFormData.url as any[]);
            setModalFormData({
              ...modalFormData,
              url: data as any,
            });
          } catch (error) {
          } finally {
            setMainPicUploadProgress(false);
          }
        },
        onRemove: () => {
          setModalFormData({
            ...modalFormData,
            url: [],
          });
        },
      },
    },
    {
      label: "标题",
      name: "title",
      type: "input",
      rules: [{ required: true, message: "请输入标题" }],
      labelCol: { span: 0, offset: 3 },
    },
    {
      label: "跳转地址",
      name: "turl",
      type: "input",
      rules: [{ required: true, message: "请输入跳转地址" }],
    },
    {
      label: "活动信息",
      name: "isnew",
      type: "input",
      labelCol: { span: 0, offset: 1 },
    },
    {
      label: "排序",
      name: "level",
      type: "input",
      params: {
        type: "number",
      },
      labelCol: { span: 0, offset: 3 },
      rules: [{ required: true, message: "请输入排序" }],
    },
    {
      label: "是否展示",
      name: "status",
      type: "radio",
      labelCol: { span: 0, offset: 1 },
      options: [
        {
          label: "展示",
          value: "0",
        },
        {
          label: "不展示",
          value: "1",
        },
      ],
    },
    {
      label: "系统类型",
      name: "systemType",
      type: "select",
      rules: [{ required: true, message: "请选择系统类型" }],
      options: systemTypeList,
    },
    {
      label: "类型",
      name: "type",
      type: "select",
      options: (app_store_type || []).map((i: { value: string }) => {
        return { ...i, value: Number(i.value) };
      }),
      labelCol: { span: 0, offset: 3 },
      rules: [{ required: true, message: "请选择类型" }],
    },
  ];
  const formTab = [
    {
      label: "标题",
      name: "title",
      type: "input",
    },
    {
      label: "活动信息",
      name: "isnew",
      type: "input",
    },
    {
      label: "是否展示",
      name: "status",
      type: "select",
      options: [
        {
          label: "展示",
          value: "0",
        },
        {
          label: "不展示",
          value: "1",
        },
      ],
    },
    {
      label: "系统类型",
      name: "systemType",
      type: "select",
      options: systemTypeList,
    },
    {
      label: "类型",
      name: "type",
      type: "select",
      options: app_store_type,
    },
  ];

  const footer = [
    {
      title: "新增",
      icon: setIcons("PlusOutlined"),
      onClick: () => setOpen(true),
    },
  ];

  const columns = [
    {
      title: "图标",
      dataIndex: "url",
      key: "url",
      fixed: "left",
      render: (data: string) => {
        return <img style={{ height: "32px" }} src={data} alt="" />;
      },
    },
    {
      title: "标题",
      dataIndex: "title",
      key: "title",
      fixed: "left",
    },
    {
      title: "活动信息",
      dataIndex: "isnew",
      key: "isnew",
    },
    {
      title: "跳转地址",
      dataIndex: "turl",
      key: "turl",
    },
    {
      title: "系统类型",
      dataIndex: "systemType",
      key: "systemType",
      render: (val: string) =>
        val ? (
          <span>{systemTypeList.find((i) => i.value === val)?.label}</span>
        ) : (
          ""
        ),
    },
    {
      title: "是否展示",
      dataIndex: "status",
      key: "status",
      render: (val: string) => (
        <Tag color="blue">{val === "0" ? "展示" : "不展示"}</Tag>
      ),
    },
    {
      title: "类型",
      dataIndex: "type",
      key: "type",
      render: (val: number) =>
        val || val === 0 ? (
          <Tag color="blue">
            {
              app_store_type?.find(
                (i: { value: string }) => i.value === String(val)
              )?.label
            }
          </Tag>
        ) : (
          ""
        ),
    },
    {
      title: "权重",
      dataIndex: "level",
      key: "level",
    },
    {
      title: "操作",
      dataIndex: "id",
      key: "id",
      fixed: "right",
      width: "120px",
      render: (val: string, rows: any) => (
        <Space>
          <Button
            size="small"
            icon={setIcons("EditOutlined")}
            type="text"
            onClick={(e) => {
              setModalFormData({
                ...rows,
                url: [{ url: rows.url, uid: rows.url, name: "" }],
              });
              setOpen(true);
            }}
          >
            修改
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getPageData();
  }, [formData]);

  useEffect(() => {
    !app_store_type && dispatch(dictInfoAsync("app_store_type") as any);
  }, []);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await pageHomeList(formData);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({
      ...formData,
      ...val,
      ypageNum: 1,
    });
  };

  const reset = () => {
    setFormData({
      isnew: "",
      status: "",
      systemType: "",
      title: "",
      ypageNum: 1,
      ypageSize: 10,
    });
  };
  const resetModal = () => {
    setModalFormData({
      status: "0",
      url: []
    });
    setOpen(false);
  };

  const confirmSend = async (val: any) => {
    console.log(val, "valvalval");
    try {
      if (modalFormData.id) {
        await pageHomeEdit({ ...val, url: val.url[0].url });
        message.success("编辑成功");
      } else {
        await pageHomeAdd({ ...val, url: val.url[0].url, versionCode: 0 });
        message.success("新增成功");
      }
      resetModal();
      getPageData();
    } catch (error) {}
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };
  return (
    <div>
      <Modal
        destroyOnHidden
        open={open}
        title={modalFormData.id ? "编辑图标" : "新增图标"}
        width="24%"
        footer={<></>}
        onCancel={resetModal}
      >
        <PageTab
          subFoot
          search={confirmSend}
          reset={resetModal}
          formTab={modalFormTab}
          initialValues={modalFormData}
        ></PageTab>
      </Modal>
      <PageTab
        search={search}
        reset={reset}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        pageChange={pageChange}
        size="small"
        rowKey="id"
        columns={columns}
        data={pageData}
        pagination={{
          current: formData.ypageNum!,
          pageSize: formData.ypageSize!,
          total: total,
        }}
      ></PageTable>
    </div>
  );
};

export default AppStoreManager;
